export default [
  {
    title: 'PATIENT INFORMATION',
    fields: [
      {
        label: 'Patient First Name',
        name: 'patient_first_name',
        type: 'text',
        span: 12,
        placeholder: 'First Name',
      },
      {
        label: 'Patient Last Name',
        name: 'patient_last_name',
        type: 'text',
        span: 12,
        placeholder: 'Last Name',
      },
      {
        name: 'patient_dob',
        label: 'Patient Date of Birth',
        type: 'date',
        span: 12,
      },
      {
        name: 'patient_gender',
        label: 'Patient Gender',
        type: 'select',
        span: 12,
        options: [
          { label: 'Male', value: "Male" },
          { label: 'Female', value: "Female" },
        ]
      },
      {
        label: 'Service Request Number',
        name: 'service_number',
        type: 'text',
        span: 12,
        placeholder: 'Service Request Number',
      },
      {
        label: 'Benefits Verified on',
        name: 'verified_at',
        type: 'text',
        span: 12,
      }
    ],
  },
  {
    title: 'FACILITY SUMMARY',
    fields: [
      {
        name: 'facility_name',
        label: 'Facility Name',
        type: 'text',
        span: 12,
      },
      {
        name: 'requestor_phone',
        label: 'Requestor Phone Number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Requestor Name',
        name: 'requestor',
        type: 'text',
        span: 12,
      },
      {
        label: 'Requestor Fax Number',
        name: 'requestor_fax',
        type: 'otp',
        length: 10,
        span: 12,
      },
      {
        label: 'Physician Name',
        name: 'physician_name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Date of Request',
        name: 'created_at',
        type: 'date',
        span: 12,
      }
    ]
  },
  {
    title: 'MEDICAL PLAN INFORMATION: Primary',
    fields: [
      {
        name: 'insurance_name',
        label: 'Insurance Name',
        type: 'text',
        span: 12,
      },
      {
        name: 'medical_plan_name',
        label: 'Plan Name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Plan Type',
        name: 'medical_plan_type',
        type: 'text',
        span: 12,
      },
      {
        label: 'Policy End Date',
        name: 'medical_plan_policy_end_date',
        type: 'date',
        span: 12,
      },
      {
        label: 'Policy Number',
        name: 'policy_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Policy Renewal Date',
        name: 'medical_plan_policy_renewal_date',
        type: 'date',
        span: 12,
      },
      {
        label: 'Group Number',
        name: 'medical_plan_group_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Payer Phone',
        name: 'medical_plan_payer_phone',
        type: 'text',
        span: 12,
      },
      {
        label: 'Policy Effective Date',
        name: 'medical_plan_policy_effective_date',
        type: 'date',
        span: 12,
      },
      {
        label: 'Facility Network Status',
        name: 'medical_plan_facility_network_status',
        type: 'text',
        span: 12,
      },
      {
        label: 'Payer Reference ID',
        name: 'medical_plan_payer_reference_id',
        type: 'text',
        span: 12,
      },
      {
        label: 'Provider Network Status',
        name: 'medical_plan_facility_network_status',
        type: 'text',
        span: 12,
      }
    ]
  },
  {
    title: 'MEDICAL PLAN COVERAGE SUMMARY (In-Network)',
    fields: [
      {
        label: 'Product Name',
        name: 'medical_product_name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Copay',
        name: 'medical_plan_copay',
        type: 'text',
        span: 12,
      },
      {
        label: 'Applicable J-Code',
        name: 'medical_plan_j_code',
        type: 'text',
        span: 12,
      },
      {
        label: 'Coinsurance',
        name: 'medical_plan_coinsurance',
        type: 'text',
        span: 12,
      },
      {
        label: 'Primary Diagnosis',
        name: 'medical_plan_primary_diagnosis',
        type: 'text',
        span: 12,
      },
      {
        label: 'Deductible',
        name: 'medical_plan_deductible',
        type: 'text',
        span: 12,
      },
      {
        label: 'Product Coverage',
        name: 'medical_plan_product_coverage',
        type: 'text',
        span: 12,
      },
      {
        label: 'Deductible Met',
        name: 'medical_plan_deductible_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'OOP Maximum',
        name: 'medical_plan_oop_maximum',
        type: 'text',
        span: 12,
      },
      {
        label: 'OOP Met',
        name: 'medical_plan_oop_maximum_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'Annual Maximum',
        name: 'medical_plan_annual_maximum',
        type: 'text',
        span: 12,
      },
      {
        label: 'Annual Maximum Met',
        name: 'medical_plan_annual_maximum_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'Maximum Plan Allowable (per fee schedule)',
        name: 'medical_plan_maximum_plan_allowable',
        type: 'text',
        span: 12,
      },
      {
        label: 'Referral Required',
        name: 'medical_plan_referral_required',
        type: 'select',
        span: 12,
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]
      },
      {
        label: 'PA Required',
        name: 'prior_pa_required',
        type: 'select',
        span: 12,
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false || null },
        ]
      },
      {
        label: 'PA on File',
        name: 'prior_pa_on_file',
        type: 'select',
        span: 12,
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false || null },
        ]
      },
      {
        label: 'PA Approval Number',
        name: 'prior_pa_approval_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'PA Approval Date',
        name: 'prior_pa_approval_date',
        type: 'date',
        span: 12,
      },
      {
        label: 'PA End Date',
        name: 'prior_pa_end_date',
        type: 'date',
        span: 12,
      },
      {
        label: 'Required Information',
        name: 'prior_required_information',
        type: 'textarea',
        span: 12,
      },
      {
        label: 'Step Therapy Required',
        name: 'prior_step_therapy_required',
        type: 'select',
        span: 12,
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]
      },
      {
        label: 'Submission Method',
        name: 'prior_submission_method',
        type: 'textarea',
        span: 12,
      },
      {
        label: 'Turnaround Time',
        name: 'prior_turnaround_time',
        type: 'text',
        span: 12,
      },
      {
        label: 'Payer PA Phone Number',
        name: 'prior_payer_pa_phone_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Medical Payer PA Contact',
        name: 'prior_medicaid_payer_pa_contact',
        type: 'text',
        span: 12,
      },
      {
        label: 'Payer PA Fax Number',
        name: 'prior_payer_pa_fax_number',
        type: 'text',
        span: 12,
      },
    ]
  },
  {
    title: 'Clinical Policy Information',
    fields: [
      {
        label: 'Clinical Policy Name',
        name: 'clinical_policy_name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Clinical Policy Number',
        name: 'clinical_policy_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Clinical Policy Location',
        name: 'clinical_policy_location',
        type: 'text',
        span: 12,
      }
    ]
  },
  {
    title: 'PHARMACY PLAN INFORMATION',
    fields: [
      {
        label: 'Payer Name',
        name: 'pharmacy_payer_name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Group Number',
        name: 'pharmacy_group_number',
        type: 'text',
        span: 12,
      },
      {
        label: 'Member ID',
        name: 'pharmacy_member_id',
        type: 'text',
        span: 12,
      },
      {
        label: 'Payer Reference ID',
        name: 'pharmacy_payer_reference_id',
        type: 'text',
        span: 12,
      },
    ]
  },
  {
    title: 'PHARMACY COVERAGE AND BENEFITS (In-Network)',
    fields: [
      {
        label: 'Product Name',
        name: 'pharmacy_product_name',
        type: 'text',
        span: 12,
      },
      {
        label: 'Copay',
        name: 'pharmacy_copay',
        type: 'text',
        span: 12,
      },
      {
        label: 'Additional Details',
        name: 'pharmacy_product_coverage',
        type: 'textarea',
        span: 12,
      },
      {
        label: 'Coinsurance',
        name: 'pharmacy_coinsurance',
        type: 'text',
        span: 12,
      },
      {
        label: 'Limitations & Restrictions',
        name: 'pharmacy_limitation_restrictions',
        type: 'text',
        span: 12,
      },
      {
        label: 'OOP Maximum',
        name: 'pharmacy_oop_maximum',
        type: 'text',
        span: 12,
      },
      {
        label: 'OOP Maximum Met',
        name: 'pharmacy_oop_maximum_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'Deductible',
        name: 'pharmacy_deductible',
        type: 'text',
        span: 12,
      },
      {
        label: 'Deductible Met',
        name: 'pharmacy_deductible_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'Annual Maximum',
        name: 'pharmacy_annual_maximum',
        type: 'text',
        span: 12,
      },
      {
        label: 'Annual Maximum Met',
        name: 'pharmacy_annual_maximum_met',
        type: 'text',
        span: 12,
      },
      {
        label: 'Maximum Plan Allowable (per fee schedule)',
        name: 'pharmacy_maximum_plan_allowable',
        type: 'text',
        span: 12,
      },
      {
        label: 'Contracted Specialty Pharmacy',
        name: 'pharmacy_contracted_specialty_pharmacy',
        type: 'text',
        span: 12,

      }
    ]
  }
]
